module.exports = __webpack_public_path__ + "img/green-dot.01d24f48.svg";